import React from 'react';
import HomePage from './HomePage';

const ShadowingPage: React.FC = () => {
  return <HomePage isShadowingView={true} />;
};

export default ShadowingPage;
